import React, { Component } from 'react';
import StationService from '../services/station_service';
import { ApiBaseUrl } from '../../http-common';
import { toast } from 'react-toastify';

class StepTwo extends Component {
  state = {
    foundDocs: [],
    loading: true,
    allFound: false,
    uploadingStation: null,
    sourcePath: localStorage.getItem("inputsPath") || "",
  };

  intervalId = null;

  // ✅ Define requiredDocs as a class property
  get requiredDocs() {
    const { station } = this.props;
    return [
      { name: 'RFID_TIN_layout.png', folder: 'schematic_plan', label: 'Upload RFID', accept: '.png' },
      { name: `RCT_${station}.xlsx`, folder: 'tables', label: 'Upload RCT', accept: '.xlsx' },
      { name: `TD_${station}.xlsx`, folder: 'tables', label: 'Upload TD', accept: '.xlsx' },
      { name: `TOC_${station}.xlsx`, folder: 'tables', label: 'Upload TOC', accept: '.xlsx' },
    ];
  }

  componentDidMount() {
    this.scanDocuments();
    this.intervalId = setInterval(this.scanDocuments, 2000); // every 2s
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  scanDocuments = async () => {
    const { outputPath, handleNext, station } = this.props;

    try {
      const res = await StationService.checkDocuments({
        path: `${outputPath}/Output_Documents/${station}`,
      });
      const foundDocs = res.data.found || [];

      const allFound = this.requiredDocs.every(doc => foundDocs.includes(doc.name));

      this.setState({ foundDocs, allFound, loading: !allFound });

      if (allFound) {
        clearInterval(this.intervalId);
        handleNext();
      }
    } catch (error) {
      console.error('Error scanning documents', error);
    }
  };

  handleUploadFile = async (e, stationName, folder) => {
    const file = e.target.files[0];
    if (!file) return; this.setState({ uploadingStation: stationName });
    const formData = new FormData(); formData.append("file", file);
    formData.append("station", stationName);
    formData.append("base_path", `${this.state.sourcePath}/Output_Documents/${stationName}/VERSION_IN_BACKEND/${folder}`);
    try {
      const response = await fetch(`${ApiBaseUrl}/upload-file`,
        { method: "POST", body: formData, });
      const data = await response.json(); if (data.success) {
        toast.success("File uploaded successfully");
        await this.scanDocuments();
      } else {
        toast.error("Upload failed: " + data.message);
      }
    }
    catch (err) {
      toast.error("Upload error: " + err.message);

    } this.setState({ uploadingStation: null });

    e.target.value = "";
  };



  handleDeleteFile = async (stationName, folder, filename) => {
    const { outputPath } = this.props;

    const filePath = `${outputPath}/Output_Documents/${stationName}/VERSION_IN_BACKEND/${folder}/${filename}`.replace(
      /\\/g,
      "/"
    );

    const fileKey = `${stationName}_${folder}_${filename}`;
    this.setState({ deletingDoc: fileKey });

    try {
      const res = await fetch(`${ApiBaseUrl}/delete-file`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ station: stationName, file_path: filePath }),
      });

      const data = await res.json();

      if (data.success) {
        toast.success("File deleted successfully");
        await this.scanDocuments(); // ✅ refresh list
      } else {
        toast.error("Delete failed: " + data.message);
      }
    } catch (err) {
      toast.error("Delete error: " + err.message);
    }

    this.setState({ deletingDoc: null });
  };

  getMimeType = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();

    const mimeTypes = {
      pdf: "application/pdf",
      png: "image/png",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      gif: "image/gif",
      bmp: "image/bmp",
      txt: "text/plain",
      csv: "text/csv",
      json: "application/json",
      xml: "application/xml",
      mp4: "video/mp4",
      mp3: "audio/mpeg",
      wav: "audio/wav",
      zip: "application/zip",
      rar: "application/vnd.rar",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ppt: "application/vnd.ms-powerpoint",
      pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    };

    return mimeTypes[ext] || "application/octet-stream";
  };

  openFile = async (folderType, station, subfolder, filename) => {
    const { outputPath } = this.props;

    const filePath = `${outputPath}/${folderType}/${station}/VERSION_IN_BACKEND${subfolder ? '/' + subfolder : ''
      }/${filename}`.replace(/\\/g, '/');

    try {
      const res = await StationService.openFile(
        { file_path: filePath, station: station },
        { responseType: 'blob' }
      );

      // 🔥 Detect MIME dynamically
      const mimeType = this.getMimeType(filename);

      // Create blob with correct type
      const blob = new Blob([res.data], { type: mimeType });

      // Create URL
      const url = URL.createObjectURL(blob);

      // Try opening in new tab for viewable types
      const viewable = ["pdf", "png", "jpg", "jpeg", "gif", "bmp", "txt"];

      if (viewable.includes(filename.split('.').pop().toLowerCase())) {
        window.open(url, "_blank");
      } else {
        // Otherwise force download
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      }

      setTimeout(() => URL.revokeObjectURL(url), 10000);

    } catch (err) {
      console.error("Error opening file:", err);
      alert("Error opening file.");
    }
  };

  getUploadConfig = (stationName, filename) => {
    // IMAGE
    if (filename === "RFID_TIN_layout.png") {
      return {
        label: "Upload Image",
        accept: ".png",
        folder: "schematic_plan",
      };
    }

    // EXCEL FILES
    return {
      label: "Upload Excel Files",
      accept: ".xlsx",
      folder: "tables",
    };
  };

  render() {
    const user = JSON.parse(localStorage.getItem("user"));
    const isAdmin = user && user.role === 1;

    const { foundDocs, allFound, uploadingDoc, deletingDoc } = this.state;
    const stationName = this.props.station;

    return (
      <div className="container py-4">
        <div
          className="mb-3"
          style={{
            color: allFound ? 'green' : 'orange',
            fontWeight: '500',
            fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
          }}
        >
          {allFound ? 'Generated Documents Successful' : 'Running Documents...'}
        </div>

        {!allFound && (
          <div className="text-center mb-4 px-2">
            <div
              className="mx-auto"
              style={{
                width: '100%',
                maxWidth: '400px',
                height: '12px',
                backgroundColor: '#ddd',
                borderRadius: '8px',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  width: `${(foundDocs.length / this.requiredDocs.length) * 100}%`,
                  height: '100%',
                  backgroundColor: '#193e6c',
                  transition: 'width 0.3s ease',
                }}
              ></div>
            </div>
          </div>
        )}

        <div className="mb-4 px-2" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
          {this.requiredDocs.map((doc, idx) => {
            const isChecked = foundDocs.includes(doc.name);
            const displayName = doc.name.replace(/\.[^/.]+$/, '');

            const docKey = `${stationName}_${doc.folder}_${doc.name}`;
            const isUploading = uploadingDoc === docKey;
            const isDeleting = deletingDoc === docKey;

            return (
              <div
                key={idx}
                className="mb-2 mt-1 d-flex align-items-center justify-content-between"
                style={{
                  color: isChecked ? 'green' : '#ccc',
                }}
              >
                {/* LEFT SIDE: checkbox + name (click only if exists) */}
                <div
                  className="d-flex align-items-center"
                  style={{
                    cursor: isChecked ? 'pointer' : 'not-allowed',
                  }}
                  onClick={() => {
                    if (isChecked) {
                      this.openFile('Output_Documents', stationName, doc.folder, doc.name);
                    }
                  }}
                >
                  <span className="me-2">{isChecked ? '☑' : '☐'}</span>
                  <span className={`file-name ${isChecked ? 'hover-underline' : ''}`}>
                    {displayName}
                  </span>
                </div>

                {/* RIGHT SIDE: upload/delete buttons */}
                <div className="d-flex align-items-center gap-2">
                  {/* If found -> show DELETE */}
                  {/* {isAdmin && isChecked && (
                    <button
                      className="btn btn-sm btn-outline-danger"
                      disabled={isDeleting || isUploading}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleDeleteFile(stationName, doc.folder, doc.name);
                      }}
                    >
                      {isDeleting ? "Deleting..." : "Delete"}
                    </button>
                  )} */}

                  {/* Upload button */}
                  {/* {isAdmin && !isChecked && (
                    <label
                      className={`btn btn-sm ${isChecked ? "btn-outline-primary" : "btn-primary"}`}
                      style={{ marginBottom: 0, cursor: isUploading ? "not-allowed" : "pointer" }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {isUploading ? "Uploading..." : doc.label}
                      <input
                        type="file"
                        hidden
                        accept={doc.accept}
                        disabled={isUploading || isDeleting}
                        onChange={(e) => this.handleUploadFile(e, stationName, doc.folder)}
                      />
                    </label>
                  )} */}

                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default StepTwo;
